import { FC } from 'react';

interface ChapterHeaderProps {
  title: string;
}

const ChapterHeader: FC<ChapterHeaderProps> = ({ title }) => {
  return (
    <h2 className="font-respira text-[40px] leading-[140%] font-normal">
      {title}
    </h2>
  );
};

export default ChapterHeader;
